var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.loading)?_c('spinner'):(_vm.icon)?_c('fa',{class:{ 'eb-animate-right': _vm.bounce, 'fa-fw': _vm.fw },attrs:{"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }